import MenuToggler from "./MenuToggler";
import Logo from "_c/Logo";
import { Link } from "@tanstack/react-router";
import SoundPlayer from "./SoundPlayer";
import ThemeToggler from "./ThemeToggler";
import { LinkBuilder } from "@/services/link-builder";
import cls from "./styles.module.css";

export default function AppHeader() {
  return (
    <div className={cls.root}>
      <Link
        className={cls.siteLink}
        aria-label="Домашняя страница"
        to={LinkBuilder.build({ route: "home" })}
      >
        <Logo className={cls.logo} />
        <span className={cls.siteTitle}>Орха</span>
      </Link>
      <div className={cls.right}>
        <SoundPlayer />
        <ThemeToggler />
        <MenuToggler />
      </div>
    </div>
  );
}
